<template>
  <div class="info-region-container">
    <div class="all-content-container" style="margin: 0 auto; width: 100%" v-if="!detailDialogVisible">
      <div class="container1">
        <div class="titlemaun" style="">
          <h4>比对告警配置</h4>
          <el-button type="primary" class="adduser" @click="handleAdd">添加</el-button>
        </div>
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="大棚名称：">
            <el-cascader expand-trigger="hover" v-model="groupIdArr" :options="groupArray" :props="optionProps" @change="groupChange" placeholder="请选择大棚名称" collapse-tags clearable></el-cascader>
          </el-form-item>
          <el-form-item label="属性名称：">
            <el-input v-model="searchForm.attributeName" placeholder="请输入属性名称" maxlength="50" show-word-limit clearable></el-input>
          </el-form-item>
          <el-form-item label="告警状态：">
            <el-select v-model="searchForm.status" clearable placeholder="请选择告警状态" @change="handleSearch">
              <el-option label="正常" value="0"></el-option>
              <el-option label="告警" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="button" @click="handleSearch">查询</el-button>
            <el-button type="button" ass="button" @click="handleRest">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="info-content-container">
        <div class="table_content1" style="margin-top: 10px">
          <el-table :data="tableData" align="center" class="data-table" v-loading="loading" style="width: 100%" :header-cell-style="{ background: '#F4F5F7' }">
            <el-table-column align="center" label="序号" width="95">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column align="center" label="大棚名称">
              <template slot-scope="scope">
                <p>{{ scope.row.groupName }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="属性名称">
              <template slot-scope="scope">
                <p>{{ scope.row.attributeName }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="差异值">
              <template slot-scope="scope">
                <p>{{ scope.row.differenceValue }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="推送模式">
              <template slot-scope="scope">
                <p>{{ toPushMode(scope.row.pushMode) }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="告警状态">
              <template slot-scope="scope">
                <p v-if="scope.row.status == 0">正常</p>
                <p v-if="scope.row.status == 1">告警</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="最近一次比对时间">
              <template slot-scope="scope">
                <p>{{ scope.row.lastComparisonDate }}</p>
              </template>
            </el-table-column>
            <el-table-column fixed="right" align="center" label="操作">
              <template slot-scope="scope">
                <el-button @click="handleDetail(scope.row)" type="text" size="small">详情</el-button>
                <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
                <el-button type="text" size="small" @click="handleDel(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-container">
          <div class="page"></div>
          <div class="pagination-content-container">
            <el-pagination background layout="prev, pager, next, jumper" class="pageTap" @current-change="handleCurrentChange" :current-page="searchForm.pageNum" :page-size="searchForm.pageSize" :total="total"></el-pagination>
          </div>
        </div>
        <el-dialog :title="addEditTitle" :visible.sync="addEditIsDialog" :before-close="handleCancel" width="600px" center style="z-index: 10000">
          <el-form ref="ruleForm" :rules="rules" :model="ruleForm" label-width="120px" class="demo-ruleForm">
            <el-row>
              <el-col :span="24">
                <el-form-item label="大棚名称：" prop="groupIdArr">
                  <el-cascader expand-trigger="hover" v-model="ruleForm.groupIdArr" :options="groupArray" :props="optionProps" @change="groupChange2" placeholder="请选择大棚名称" collapse-tags clearable></el-cascader>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="属性名称：" prop="attributeName">
                  <el-input v-model="ruleForm.attributeName" placeholder="请输入属性名称" maxlength="50" show-word-limit clearable>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="差异值：" prop="differenceValue">
                  <el-input-number v-model="ruleForm.differenceValue" placeholder="请输入属性名称" :min="0" :max="99999999" size="small" :precision="2" :step="1">
                  </el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="推送模式：" prop="pushModeArr">
                  <el-select v-model="ruleForm.pushModeArr" placeholder="请选择推送模式" multiple collapse-tags clearable>
                    <el-option v-for="item in pushModeoptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="handleCancel">取 消</el-button>
            <el-button type="primary" @click="handleSave">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
    <div v-if="detailDialogVisible">
      <div class="container1">
        <div class="titlemaun" style="">
          <h4>比对告警详情</h4>
          <el-button type="primary" class="adduser" @click="handleReturn">返回</el-button>
        </div>
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="大棚名称：" style="margin-right: 30px !important">
            <span>{{ detailForm.groupName }}</span>
          </el-form-item>
          <el-form-item label="属性名称：" style="margin-right: 30px !important">
            <span>{{ detailForm.attributeName }}</span>
          </el-form-item>
          <el-form-item label="差异值：" style="margin-right: 30px !important">
            <span>{{ detailForm.attributeName }}</span>
          </el-form-item>
          <el-form-item label="推送模式：" style="margin-right: 30px !important">
            <span>{{ toPushMode(detailForm.pushMode) }}</span>
          </el-form-item>
          <el-form-item label="告警状态：" style="margin-right: 30px !important">
            <span v-if="detailForm.status == 0">正常</span>
            <span v-if="detailForm.status == 1">告警</span>
          </el-form-item>
          <el-form-item label="最近一次比对时间：" style="margin-right: 30px !important">
            <span>{{ detailForm.lastComparisonDate }}</span>
          </el-form-item>
        </el-form>
      </div>
      <div class="info-content-container">
        <div class="table_content1" style="margin-top: 10px">
          <el-table :data="detailTableData" align="center" class="data-table" v-loading="loading" style="width: 100%" :header-cell-style="{ background: '#F4F5F7' }">
            <el-table-column align="center" label="序号" width="95">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column label="设备名称">
              <template slot-scope="scope">
                <p>{{ scope.row.deviceName }}</p>
              </template>
            </el-table-column>
            <el-table-column label="属性名称">
              <template slot-scope="scope">
                <p>{{ scope.row.attributeName }}</p>
              </template>
            </el-table-column>
            <el-table-column label="采集数据">
              <template slot-scope="scope">
                <p>{{ scope.row.value }}</p>
              </template>
            </el-table-column>
            <el-table-column label="采集时间">
              <template slot-scope="scope">
                <p>{{ scope.row.updateTime }}</p>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      searchForm: {
        // 查询条件字段
        pageNum: 1,
        pageSize: 10,
        groupId: '',
        attributeName: '',
        status: ''
      },
      groupIdArr: [],
      total: 0, // 总数
      tableData: [],
      ruleForm: {
        // 添加、编辑弹窗表单
        id: '',
        groupIdArr: [],
        groupId: '',
        attributeName: '',
        differenceValue: '',
        pushModeArr: [],
        pushMode: ''
      },
      rules: {
        // 添加、编辑弹窗表单规则
        groupIdArr: [
          {
            required: true,
            message: '请选择大棚名称',
            trigger: 'change'
          }
        ],
        attributeName: [
          {
            required: true,
            message: '请输入属性名称',
            trigger: 'blur'
          }
        ],
        differenceValue: [
          {
            required: true,
            message: '请输入差异值',
            trigger: 'blur'
          }
        ],
        pushModeArr: [
          {
            required: false,
            message: '请选择推送模式',
            trigger: 'change'
          }
        ]
      },
      addEditTitle: '添加比对告警配置', // 添加编辑弹窗标题
      addEditIsDialog: false, // 添加编辑弹窗是否显示
      groupArray: [], // 大棚名称数组
      pushModeoptions: [
        // 推送模式数组
        {
          value: '0',
          label: '邮箱发送'
        },
        {
          value: '1',
          label: '短信发送'
        },
        {
          value: '2',
          label: 'APP推送'
        },
        {
          value: '3',
          label: '小程序推送'
        },
        {
          value: '4',
          label: '语音拨号提醒'
        }
      ],
      detailForm: {
        // 详情表单
        id: '',
        groupName: '',
        attributeName: '',
        differenceValue: '',
        pushMode: '',
        status: '',
        lastComparisonDate: ''
      },
      detailTableData: [], // 详情实时数据
      detailDialogVisible: false, // 详情表单是否显示
      optionProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        checkStrictly: true,
        multiple: false
      }
    }
  },
  created() {
    this.searchForm.paramId = this.$route.query.comparisonParamId
    this.ruleForm.paramId = this.$route.query.comparisonParamId
    this.comparisonParamId = this.$route.query.comparisonParamId

    // 获取分组列表
    this.getGroupList()

    // 查询
    this.getList()
  },
  methods: {
    // 查询
    handleSearch() {
      this.searchForm.pageNum = 1
      this.getList()
    },
    // 重置
    handleRest() {
      this.searchForm = {
        pageNum: 1,
        pageSize: 10,
        groupId: '',
        attributeName: '',
        status: ''
      }
      this.groupIdArr = []
      this.getList()
    },
    // 分页查询
    handleCurrentChange: function (currentPage) {
      this.searchForm.pageNum = currentPage
      this.getList()
    },
    // 分页获取列表
    getList() {
      this.loading = true
      this.$api.comparison.getConfigComparisonList(this.searchForm).then((res) => {
        if (res.code == 200) {
          this.tableData = res.data
          this.total = res.count
          this.loading = false
        }
      })
    },
    // 删除
    handleDel(row) {
      this.$confirm('是否删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$api.comparison.delConfigComparison(row.id).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.getList()
            }
          })
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },
    // 编辑
    handleEdit(row) {
      this.addEditIsDialog = true
      this.addEditTitle = '编辑比对告警配置'
      this.ruleForm.id = row.id

      // 获取详情
      this.$api.comparison.getConfigComparison({ id: row.id }).then((res) => {
        if (res.code == 200) {
          res.data.pushModeArr = res.data.pushMode ? res.data.pushMode.split(',') : []

          this.ruleForm = res.data
          this.ruleForm.groupIdArr = [this.getParentGroupId(res.data.groupId), res.data.groupId]
        }
      })
    },
    // 添加
    handleAdd() {
      this.addEditIsDialog = true
      this.addEditTitle = '添加比对告警配置'
      this.ruleForm.id = ''
    },
    // 取消
    handleCancel() {
      this.$refs['ruleForm'].resetFields()
      this.addEditIsDialog = false
    },
    // 保存
    handleSave() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.ruleForm.pushMode = this.ruleForm.pushModeArr ? this.ruleForm.pushModeArr.toString() : ''
          this.$api.comparison.saveConfigComparison(this.ruleForm).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.handleCancel()
              this.handleSearch()
            }
          })
        }
      })
    },
    // 大棚下拉切换
    groupChange() {
      // 不是三级分类
      if (this.groupIdArr.length !== 2) {
        this.groupIdArr = []
        return
      }
      this.searchForm.groupId = this.groupIdArr[1]
      this.getList()
    },
    // 大棚下拉切换2
    groupChange2() {
      // 不是三级分类
      if (this.ruleForm.groupIdArr.length !== 2) {
        this.ruleForm.groupIdArr = []
        return
      }
      this.ruleForm.groupId = this.ruleForm.groupIdArr[1]
    },
    // 获取分组列表
    getGroupList() {
      this.$api.system.getGroupList().then((res) => {
        if (res.code == 200) {
          this.groupArray = res.data
        }
      })
    },
    // 获取上级分组id
    getParentGroupId(groupId) {
      let parentGroupId = 0
      let children = []
      this.groupArray.map((item) => {
        if (item.children) {
          children = item.children
          let isEnd = false
          children.every(function (val2) {
            if (val2.id == groupId) {
              parentGroupId = val2.parentId
              isEnd = true
            }
            return val2.id != groupId
          })
          return !isEnd
        }
      })

      return parentGroupId
    },
    // 推送模型转名称
    toPushMode(pm) {
      return pm == undefined || pm == null ? '' : pm.toString().replace('0', '邮箱发送').replace('1', '短信发送').replace('2', 'APP推送').replace('3', '小程序推送').replace('4', '语音拨号提醒')
    },
    // 详情
    handleDetail(row) {
      this.detailDialogVisible = true
      // 获取比对告警详情
      this.getConfigComparisonDetail(row.id)
      // 获取比对告警实时数据
      this.getConfigComparisonData(row.id)
    },
    // 获取比对告警详情
    getConfigComparisonDetail(id) {
      this.$api.comparison.getConfigComparison({ id: id }).then((res) => {
        if (res.code == 200) {
          this.detailForm = res.data
        } else {
          this.$toaster.error(res.msg)
        }
      })
    },
    // 获取比对告警实时数据
    getConfigComparisonData(id) {
      this.$api.comparison.getConfigComparisonData({ id: id }).then((res) => {
        if (res.code == 200) {
          this.detailTableData = res.data
        } else {
          this.$toaster.error(res.msg)
        }
      })
    },
    // 返回
    handleReturn() {
      this.detailDialogVisible = false
    }
  }
}
</script>
<style lang="scss" scoped>
.container1 {
  border: 1px solid rgba(232, 232, 232, 1);
}

.el-button {
  line-height: 0;
}

.all-content-container {
  width: 100%;
}

.titlemaun {
  display: flex;
  justify-content: space-between;
  height: 48px;
  border-bottom: 1px solid #ededed;
}

h4 {
  font-size: 14px;
  font-weight: 550;
  color: #000;
  height: 48px;
  line-height: 48px;
  padding-left: 18px;
}

.demo-ruleForm {
  width: 95%;
  margin: 0 auto;
  padding-top: 10px;

  .el-row {
    margin-bottom: 20px;
  }

  .el-select {
    width: 100% !important;
  }

  .el-input-number {
    width: 100% !important;
  }

  .el-cascader {
    width: 100% !important;
    margin-bottom: 0px !important;
  }
}
</style>